import patterns from '../../../shared/contact-phone-patterns.json'

function normalizePhone(formattedNumber) {
  return formattedNumber.replace(/\s+/g, '')
}

const regex = {
  spanishMobile: new RegExp(patterns.spanishMobile),
  europeanMobile: new RegExp(patterns.europeanMobile),
  norwegianMobile: new RegExp(patterns.norwegianMobile),
  nonEuropeanPhone: new RegExp(patterns.nonEuropeanPhone),
}

export function isSpanishMobile(formattedNumber) {
  return regex.spanishMobile.test(normalizePhone(formattedNumber))
}

export function isEuropeanMobile(formattedNumber) {
  return regex.europeanMobile.test(normalizePhone(formattedNumber))
}

export function isNorwegianMobile(formattedNumber) {
  return regex.norwegianMobile.test(normalizePhone(formattedNumber))
}

export function isNonEuropeanPhone(formattedNumber) {
  return regex.nonEuropeanPhone.test(normalizePhone(formattedNumber))
}

export function isValidContactPhone(formattedNumber) {
  return (
    isSpanishMobile(formattedNumber) ||
    isEuropeanMobile(formattedNumber) ||
    isNorwegianMobile(formattedNumber) ||
    isNonEuropeanPhone(formattedNumber)
  )
}

export function validateContactPhoneField(formattedNumber, fieldName) {
  if ('shipping_address_phone' === fieldName) {
    return ''
  }

  if ('phone_portability' === fieldName) {
    return isSpanishMobile(formattedNumber) ? '' : 'phone_spanish_mobile_required'
  }

  return isValidContactPhone(formattedNumber) ? '' : 'phone_invalid'
}
